import { useState } from "react";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { toast } from "react-hot-toast";
import TickMarkIcon from "@admin/components/SVG/TickMarkIcon";
import { useUpdateAssignmentMarkMutation } from "@features/assignmentMarks/assignmentMarksApi";

const AssignmentMark = ({ assignmentMark }) => {
  const {
    id,
    student_name,
    title,
    createdAt,
    totalMark,
    mark: obtainedMark,
    repo_link,
    status,
  } = assignmentMark || {};

  const [mark, setMark] = useState(totalMark);

  const [updateAssignmentMark] = useUpdateAssignmentMarkMutation();

  const handleUpdateMark = async () => {
    if (+mark < 0 || +mark > 100) {
      toast.error("Mark should be between 0 to 100");
      return;
    }

    const data = {
      mark,
      status: "published",
    };

    const response = await updateAssignmentMark({ id, data });

    if (response?.data) {
      toast.success("Assignment mark updated successfully!");
    } else {
      toast.error("Assignment mark updated failed!");
    }
  };

  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">
        {format(
          utcToZonedTime(new Date(createdAt), "Asia/Dhaka"),
          "dd MMM yyyy hh:mm:ss a",
          {
            timeZone: "Asia/Dhaka",
          }
        )}
      </td>
      <td className="table-td">{student_name}</td>
      <td className="table-td">{repo_link}</td>
      {status === "pending" ? (
        <td className="table-td input-mark">
          <input
            min="0"
            max="100"
            value={mark}
            onChange={(e) => setMark(e.target.value)}
          />
          <button onClick={handleUpdateMark}>
            <TickMarkIcon />
          </button>
        </td>
      ) : (
        <td className="table-td">{obtainedMark}</td>
      )}
    </tr>
  );
};

export default AssignmentMark;
